var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40001451_8869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2124 23.2499C0.974904 23.2499 0.412404 22.3499 0.974904 21.2624L10.9874 1.5749C11.5499 0.487402 12.4499 0.487402 13.0124 1.5749L23.0249 21.2624C23.5874 22.3499 23.0249 23.2499 21.7874 23.2499H2.2124Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4252 8.8502L11.4752 15.7877C11.5877 16.4627 12.4502 16.4627 12.5627 15.7877L13.5752 8.8502C13.7627 6.1502 10.2377 6.1502 10.4252 8.8502Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 20.1754C12.8701 20.1754 13.5753 19.4702 13.5753 18.6004C13.5753 17.7305 12.8701 17.0254 12.0003 17.0254C11.1304 17.0254 10.4253 17.7305 10.4253 18.6004C10.4253 19.4702 11.1304 20.1754 12.0003 20.1754Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40001451_8869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneWarning);
export default __webpack_public_path__ + "static/media/emojione_warning.21432498814438d49d686e9d77f5b51b.svg";
export { ForwardRef as ReactComponent };